import Cookies from 'universal-cookie'
// import { AppDispatch } from '../redux/store'
// import * as userDucks from '../redux/ducks/userDucks'

const cookies = new Cookies()

export function logOut() {
  const URL_LOGOUT_ALL_SYSTEM = (process.env.REACT_APP_AUTH_URL || "http://localhost:3000") + '/logout-all'
  cookies.remove('access_muahang_token', { path: '/' })
  cookies.remove('user_info', { path: '/' })
  window.location.href = `${URL_LOGOUT_ALL_SYSTEM}?hethong=muahang&redirect_url=${location.pathname}`
}

// get
export function getAccessToken() {
  return cookies.get('access_muahang_token')
}

export function getUserInfo() {
  return cookies.get('user_info')
}


export function getProjectInfo() {
  return cookies.get('project_info')
}

export function getBranchInfo() {
  return cookies.get('branch_info')
}

// Set
export function saveAccessToken(value: string) {
  return cookies.set('access_muahang_token', value, {
    path: '/',
  })
}

export function saveUserInfo(value: string) {
  return cookies.set('user_info', value, {
    path: '/',
  })
}

export function saveProjectInfo(value: string) {
  return cookies.set('project_info', value, {
    path: '/',
  })
}

export function saveBranchInfo(value: string) {
  return cookies.set('branch_info', value, {
    path: '/',
  })
}



export function isLoggedIn() {
  return !!getAccessToken()
}
